'use client'

import { FC } from 'react'
import { useGetTranslations } from '@/root/shared-hooks'
import { useSessionCountdown } from '@/root/modules/shared/EditReservation/hooks/useSessionCountdown'
import { testIds } from '@/root/shared-consts'

interface SessionExpiryBannerProps {
  expireAt: string // UTC ISO date string
  onExpiringSoon?: () => void
}

export const SessionExpiryBanner: FC<SessionExpiryBannerProps> = ({ expireAt, onExpiringSoon }) => {
  const { getTranslation } = useGetTranslations()
  const { totalMinutes, seconds, isExpiringSoon, isExpired } = useSessionCountdown({ expireAt, onExpiringSoon })

  const timeRemaining = isExpired
    ? getTranslation('editSessionExpired')
    : getTranslation('editSessionRemaining', {
        time: totalMinutes > 0 ? `${totalMinutes}m ${seconds}s` : `${seconds}s`,
      })

  return (
    <div
      data-testid={testIds.edit.sessionBanner}
      className={`rounded-lg border px-4 py-2 text-sm ${
        isExpiringSoon
          ? 'border-warning-medium-light bg-warning-lightest text-warning-dark'
          : 'border-complimentary-normal-light bg-complimentary-lightest text-complimentary-dark'
      }`}
    >
      <div className="flex items-center gap-2">
        <span className="font-medium">{getTranslation('editSessionLabel')}</span>
        <span className="font-semibold">{timeRemaining}</span>
      </div>
      {isExpiringSoon && !isExpired && <p className="mt-1 text-xs">{getTranslation('editSessionExpiringSoon')}</p>}
    </div>
  )
}
